import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { OrderAllocatedExpense } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 1192. 支払タスクプロジェクト按分費用一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:payment_task_id/order_allocated_expenses
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
};
const orderAllocatedExpenses = (props: Props): Promise<OrderAllocatedExpense[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/order_allocated_expenses`
  );
};

export const useOrderAllocatedExpenses = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => orderAllocatedExpenses(props),
  });
};

export const useInvalidateOrderAllocatedExpenses = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'purchase_orders',
    props.purchase_order_id,
    'payment_tasks',
    props.task_id,
    'order_allocated_expenses',
  ];
};
